<template>
  <woot-modal
    v-if="showForwardModal"
    :show="showForwardModal"
    size="modal--large"
    :on-close="onForwardCancel"
    class="forward-email-modal"
  >
    <div class="column">
      <woot-modal-header-v2
        :header-title="$t('FORWARD_EMAIL.TITLE')"
        :header-content="$t('FORWARD_EMAIL.DESCRIPTION')"
      >
        <template #titleIcon>
          <span class="material-symbols-outlined scale-x-[-100%] text-gray-500">
            reply
          </span>
        </template>
      </woot-modal-header-v2>
      <forward-email-form
        :forward-message="forwardMessageData"
        :inbox="inbox"
        :on-submit="onForwardSubmit"
        @cancel="onForwardCancel"
        @forward-sent="onForwardSent"
      />
    </div>
  </woot-modal>
</template>
<script>
import ForwardEmailForm from './ForwardEmailForm.vue';

export default {
  components: { ForwardEmailForm },
  props: {
    showForwardModal: {
      type: Boolean,
      required: true,
    },
    forwardMessageData: {
      type: Object,
      required: true,
    },
    inbox: {
      type: Object,
      required: true,
    },
    onForwardCancel: {
      type: Function,
      required: true,
    },
    onForwardSent: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onForwardSubmit(payload) {
      return this.$store.dispatch('contactConversations/create', payload);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  &.forward-email-modal {
    .modal-container {
      @apply rounded-[12px];
    }
  }
}
</style>
